import useTeams from "@/hooks/useTeams";
import React from "react";
import Select from "../Select";

export default function TeamSelectDeprecated(
  props: React.DetailedHTMLProps<
    React.SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  >
) {
  const { teams } = useTeams();

  return (
    <>
      <select {...props}>
        <option key={""} value={""}>
          -- Select --
        </option>
        {teams.map((team) => (
          <option key={team.id} value={team.id}>
            {team.name}
          </option>
        ))}
      </select>
    </>
  );
}

export function TeamSelect({
  className,
  value,
  onChange,
  placeholder,
  allowNull
}: {
  className?: string;
  value: number | undefined | null;
  onChange: (value: number | null) => void;
  placeholder?: string;
  allowNull?: boolean;
}) {
  const { teamOptions } = useTeams();

  const options = allowNull
    ? [{ label: placeholder ?? "-- None --", value: null as unknown as number }, ...teamOptions]
    : teamOptions;

  return (
    <Select<number>
      className={className}
      value={value ?? undefined}
      options={options}
      onChange={(v) => onChange(v ?? null)}
    />
  );
}
